module.exports = __webpack_public_path__ + "static/media/infoJumbo1.90cc208f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/carif/images/infoJumbo1.jpg
// module id = 554
// module chunks = 0